import { createSignal } from "solid-js";
import { NegativeIndexOutOfBoundsError } from "../../../utils/errors.js";
import { getNativeExtensions, signalExtender, } from "../../../utils/signal.js";
const arrayMutators = [
    "copyWithin",
    "fill",
    "pop",
    "push",
    "reverse",
    "shift",
    "sort",
    "splice",
    "unshift",
];
function createArray(value, options) {
    return createArray.wrap(createSignal(value, options));
}
createArray.wrap = (signal) => {
    return signalExtender(signal).extend(([state, setState]) => [
        {},
        {
            at(index, value) {
                const i = index < 0 ? state().length + index : index;
                if (i < 0)
                    throw NegativeIndexOutOfBoundsError.build(state(), index);
                // Making a copy has the most predictable behavior when setting an
                // index greater than array length
                const copy = [...state()];
                copy[i] = value;
                setState(copy);
                return value;
            },
            find(predicate, value) {
                const index = state().findIndex(predicate);
                if (index === -1)
                    return;
                setState.at(index, value);
                return state()[index];
            },
            ...getNativeExtensions(() => [...state()], setState, arrayMutators),
        },
    ]);
};
export default createArray;
